import { render } from "./ForDoubleTrade.vue?vue&type=template&id=1758732c&scoped=true&ts=true"
import script from "./ForDoubleTrade.vue?vue&type=script&lang=ts"
export * from "./ForDoubleTrade.vue?vue&type=script&lang=ts"

import "./ForDoubleTrade.vue?vue&type=style&index=0&id=1758732c&scoped=true&lang=scss"

import exportComponent from "/data/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1758732c"]])

export default __exports__